module.exports = __webpack_public_path__ + "img/194e3ea.jpg";